module.exports = {
  boxShadowContainer: "0px 2px 4px rgba(45, 51, 63, .2)",
};